import React, { useState, useEffect, useContext } from 'react'
import createAuth0Client from '@auth0/auth0-spa-js'

const DEFAULT_REDIRECT_CALLBACK = (appState) => {
  if (appState && appState.isByob) {
    window.location.replace('/registration/aigp-onboarding/quickbooks');
  } else {
    window.location.replace('/registration/onboarding');
  }
}
const USER_METADATA_URI = `${process.env.REACT_APP_USER_METADATA_URI}/user_metadata`
const APP_METADATA_URI = `${process.env.REACT_APP_USER_METADATA_URI}/app_metadata`

export const Auth0Context = React.createContext()
export const useAuth0 = () => useContext(Auth0Context)
export const Auth0Provider = ({
  children,
  onRedirectCallback = DEFAULT_REDIRECT_CALLBACK,
  redirect_uri,
  ...initOptions
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState()
  const [user, setUser] = useState()
  const [auth0Client, setAuth0] = useState()
  const [loading, setLoading] = useState(true)
  const [popupOpen, setPopupOpen] = useState(false)

  useEffect(() => {
    const initAuth0 = async () => {
      const auth0FromHook = await createAuth0Client({
        redirect_uri,
        ...initOptions,
      })
      setAuth0(auth0FromHook)

      if (window.location.search.includes('code=') && window.location.search.includes('state=')) {
        const { appState } = await auth0FromHook.handleRedirectCallback()
        onRedirectCallback(appState)
      }
      const isCurrentlyAuthenticated = await auth0FromHook.isAuthenticated()

      if (isCurrentlyAuthenticated) {
        const authUser = await auth0FromHook.getUser()
        const legacyFreelancerId = authUser[APP_METADATA_URI].userId
        const isFirmProfile = authUser[USER_METADATA_URI].isFirmProfile
        console.log('isFirmProfile 2', isFirmProfile)

        setUser({
          ...authUser,
          legacyFreelancerId,
          app_metadata: {
            ...authUser[APP_METADATA_URI],
          },
          user_metadata: {
            ...authUser[USER_METADATA_URI],
          },
        })
        console.log('user is ', user, user.user_metadata.isFirmProfile, user.user_metadata)
      }

      setIsAuthenticated(isCurrentlyAuthenticated)
      setLoading(false)
    }
    initAuth0()
    // eslint-disable-next-line
  }, [])

  const loginWithPopup = async (params = {}) => {
    setPopupOpen(true)
    try {
      await auth0Client.loginWithPopup(params)
    } catch (error) {
      console.error(error)
    } finally {
      setPopupOpen(false)
    }
    const loginUser = await auth0Client.getUser()
    setUser(loginUser)
    setIsAuthenticated(true)
  }

  const handleRedirectCallback = async () => {
    setLoading(true)
    await auth0Client.handleRedirectCallback()
    const loginUser = await auth0Client.getUser()
    setLoading(false)
    setIsAuthenticated(true)
    setUser(loginUser)
  }

  return (
    <Auth0Context.Provider
      value={{
        isAuthenticated,
        user,
        loading,
        popupOpen,
        loginWithPopup,
        handleRedirectCallback,
        getIdTokenClaims: (...p) => auth0Client.getIdTokenClaims(...p),
  loginWithRedirect: (...p) => auth0Client.loginWithRedirect(...p),
        getTokenSilently: (...p) => auth0Client.getTokenSilently(...p),
        getTokenWithPopup: (...p) => auth0Client.getTokenWithPopup(...p),
        logout: (...p) => auth0Client.logout(...p),
        logoutWithRedirect: (...p) => auth0Client.logout({ returnTo: redirect_uri, ...p }),
      }}
    >
      {children}
    </Auth0Context.Provider>
  )
}
